import {AfterViewInit, Component, ElementRef, Inject, Input, OnInit, Output, ViewChild} from "@angular/core";
import {Subject} from "rxjs";
import {CurrencyService} from "@aparraga/ahoracrypto-client-common/src/app/common/currency/currency.service";
import {DOCUMENT} from "@angular/common";
import {DeviceDetectorService} from "ngx-device-detector";

import { Modal } from 'flowbite';
import {IS_BROWSER} from "@aparraga/ahoracrypto-client-common/src/app/common/utils/injectiontokens";


@Component({
    templateUrl: './currenciespopup.component.html',
    styleUrls: ['./currenciespopup.component.scss'],
    selector: 'currenciespopup',
    standalone: false
})
export class CurrenciesPopupComponent implements AfterViewInit {

  @Output() public onCurrencySelected = new Subject<any>();

  @Input() public selectedCurrencyIsoCode = null;
  @ViewChild('currencyList') protected currencyList: ElementRef<HTMLElement>;
  @ViewChild('searchinput') protected searchInputElement: ElementRef<HTMLElement>;

  public currencies = [];

  public selectedCurrency;
  protected modal;

  public filter = "";

  constructor(protected currencyService: CurrencyService,
              @Inject(IS_BROWSER) protected isBrowser: boolean,
              protected deviceService: DeviceDetectorService,
              @Inject(DOCUMENT) private document: Document) {
    this.selectedCurrency = currencyService.getSelectedCurrency();
    this.currencies = currencyService.getCurrencies();
  }

  ngAfterViewInit() {
    if(this.isBrowser) {
      this.modal = new Modal(this.currencyList.nativeElement, {
        backdropClasses: 'bg-gray-900 bg-opacity-50 dark:bg-opacity-80 fixed inset-0',
        onShow: () => {
          this.document.body.classList.add('on-modal');
        },
        onHide: () => {
          this.document.body.classList.remove('on-modal');
        }
      });
    }
  }

  show() {
    this.modal.show();
    if(!this.deviceService.isMobile()) {
      this.searchInputElement.nativeElement.focus();
    }
  }

  hide() {
    this.modal.hide();
  }

  selectCurrency(currency) {
    this.selectedCurrency = currency;
    this.currencyService.setSelectedCurrency(currency.code)
    this.onCurrencySelected.next(this.selectedCurrency.code);
    this.hide();
  }


}
